export enum ListingTypeKey {
    DESK = 1,
    MEETING_ROOM = 2,
    OFFICE_ROOM = 3
}
